import type { PackageStatus } from '@/features/package/domain/enums/PackageStatus'
import type { MonitoringUserEntity } from '../MonitoringUserEntity'
import type { MonitoringServiceEntity } from '../MonitoringServiceEntity'
import type { MonitoringPackageAddressEntity } from './MonitoringPackageAddressEntity'
import type { PackagePayType } from '@/features/package/domain/enums/PackagePayType'
import type { PackageDirectionType } from '@/features/package/domain/enums/PackageDirectionType'
import type { PackageItemType } from '@/features/package/domain/enums/PackageItemType'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'

export class PackageMonitoringEntity {
  id?: string
  packageId?: string
  status?: PackageStatus
  statusUpdatedAt?: string
  user?: MonitoringUserEntity
  service?: MonitoringServiceEntity
  address?: MonitoringPackageAddressEntity
  referenceCode?: string | null
  createdAt?: string
  payType?: PackagePayType
  deliveryFeePrice?: number
  senderName?: string | null
  senderPhoneNumber?: string | null
  receiverName?: string | null
  receiverPhoneNumber?: string | null
  directionType?: PackageDirectionType
  vehicleTemplateType?: VehicleTemplateType | null
  itemType?: PackageItemType
  hasActiveSearch?: boolean
  assignedDriver?: {
    id?: number
    workingPhoneNumber?: string
    fullName?: string
    avatarImageUrl?: string
  }
}
